import React from "react";
import { SubSectionLocked } from "../SubSectionLocked/SubSectionLocked";
import { SubSectionUnlocked } from "../SubSectionUnlocked/SubSectionUnlocked";
import { useAdminPanelStore } from "features/AdminPanel/store/useAdminPanelStore";
import { getSectionStates } from "features/AdminPanel/modules/utils/AdminPanel.utils";

export const SubSection = ({ subSection }) => {
  const { key, lockedStatesArr } = subSection || {};

  const sectionConfig = useAdminPanelStore((state) => state.sectionConfig);

  const status = sectionConfig[key]?.status;

  const { isPlanLocked, verificationNotCompleted, hide } = getSectionStates({
    status,
  });
  const defaultStatestoShowLocked = isPlanLocked || verificationNotCompleted;
  // if lockedStatesArr is there and the status includes in that array , then only
  const showLocked = lockedStatesArr
    ? lockedStatesArr.includes[status]
    : defaultStatestoShowLocked;

  if (hide) return <></>;

  return showLocked ? (
    <SubSectionLocked subSection={subSection} />
  ) : (
    <SubSectionUnlocked subSection={subSection} />
  );
};
